import BaseTasksChangeDialog from "./BaseTasksChangeDialog";
import UsersSelector from "../../../panels/usersAssignedToHierarchy/UsersSelector";
import messageResource from "../../../messageResource";
import {addDefaultUserGroup} from "../../../util/groupUtils";
import HierarchySelectorDropdownButton from '../../../controls/selectorControls/at_hierarchy_selector_dropdown_button'

export default class AssignTasksToDialog extends BaseTasksChangeDialog {

    constructor({
        $containerElement,
        cancelHandler = () => {},
        submitHandler = () => {},
        selectionChangedCb = () => {},
    }) {
        super({$containerElement, cancelHandler, submitHandler})
        this.selectionChangedCb = selectionChangedCb

        this.state = {
            ...this.state,
            selectedUserIds: [],
            users: [],
            userGroups: [],
            timeZoneGroups: [],
            userGroupsEnabled: false,
            timeZoneGroupsEnabled: false,
            userRatesEnabled: false,
            billingTypesEnabled: false,
            timeTrackApprovalEnabled: false,
            loggedInUserId: -1,
        }

        this.onStatePropertyChanged('selectedUserIds', (selectedUserIds) => {
            this.$el.toggleClass('assignEnabled', selectedUserIds && selectedUserIds.length > 0)
        })

        this.onStateChanged(() => {
            const newState = {
                selection: this.state.selectedUserIds,
                users: this.state.users,
                userGroups: addDefaultUserGroup(this.state.userGroups),
                timeZoneGroups: this.state.timeZoneGroups,
                userGroupsEnabled: this.state.userGroupsEnabled,
                timeZoneGroupsEnabled: this.state.timeZoneGroupsEnabled,
                isURAEnabled: this.state.userRatesEnabled,
                isBTYEnabled: this.state.billingTypesEnabled,
                isTTAEnabled: this.state.timeTrackApprovalEnabled,
                title: messageResource.getMessage("assign_to.tasks.users_selector.title")
            }

            if (!this.usersSelector) {
                this.usersSelector = new UsersSelector({
                    selectionCallback: selectorData => {
                        this.selectionChangedCb(selectorData.addedUserIds, selectorData.removedUserIds)
                    },
                    showPermissionIcons: true,
                    canDeselectUser: function(user) {
                        return user.canBeModified;
                    },
                    resetOnHide: false
                }).init()

                this.usersSelector.setState(newState);
            } else {
                this.usersSelector.setState(newState)
            }

            // !important hack! cause UserSelector creates new menu after state changed - need to relink button and menu
            // !don not write similar code. It's cheap solution of big problem integrating old code with react programming model
            // if button not exists or linked menu already not actual - create new button and link with actual menu
            if(!this.chooseUserButton || this.chooseUserButton.menu !== this.usersSelector.menu) {
                if(this.chooseUserButton) {
                    this.chooseUserButton.menu = null // because ext.js cannot destroy menu without problems
                    this.chooseUserButton.destroy() // delete prev button
                }
                this.chooseUserButton = new HierarchySelectorDropdownButton({
                    renderTo: this.$el.find(".selectorContainer")[0],
                    menu: this.usersSelector.menu
                })
                if (!this.state.selectedUserIds) {
                    this.chooseUserButton.setText(messageResource.getMessage("assign_to.tasks.users_selector.empty_selection_text"));
                } else {
                    this.usersSelector.menu.panel.fireChangeEvent()
                }
            }
        })
    }

    messageKeys() {
        return {
            labelText: "assign_to.tasks.users_selector.label",
            cancelButtonText: "common.cancel",
            submitButtonText: "assign_to.tasks.assign"
        };
    }

    afterRender() {
        super.afterRender()
        this._updateTitleText()
    }

    onSubmit() {
        if (!this.state.selectedUserIds || this.state.selectedUserIds.length === 0 || this.state.saving)
            return

        this.submitHandler(this.state.selectedUserIds)
    }

    titleText() {
        if (this.state.numberOfTasks === 1)
            return messageResource.getMessage("assign_to.tasks.assign_selected_task_to");
        return messageResource.getMessage("assign_to.tasks.assign_selected_tasks_to", [this.state.numberOfTasks]);
    }
}



// WEBPACK FOOTER //
// ./web/js/taskManagement/bulkOperations/components/AssignTasksToDialog.js